<template lang="pug">
  v-text-field(
    label='Заголовок H2'
    v-model='block.value'
    @input='$emit("update", block)'
    autofocus
  )
</template>

<script>
import BaseBlock from './BaseBlock'
export default {
  extends: BaseBlock
}
</script>
